import { OnboardingActionTypes } from './onboarding.types';

const onboardingRegisterRequest = ({
  hostingId, origin, domain, skip = false,
}) => ({
  type: OnboardingActionTypes.ONBOARDING_REGISTER_REQUEST,
  payload: {
    hostingId, origin, domain, skip,
  },
});
const onboardingRegisterSuccess = ({ builderId }) => ({ type: OnboardingActionTypes.ONBOARDING_REGISTER_SUCCESS, payload: { builderId } });
const onboardingRegisterFailure = () => ({ type: OnboardingActionTypes.ONBOARDING_REGISTER_FAILURE });

const onboardingUpdateRequest = ({
  hostingId, origin, domain, builder, finished, step,
}) => ({
  type: OnboardingActionTypes.ONBOARDING_UPDATE_REQUEST,
  payload: {
    hostingId, origin, domain, builder, finished, step,
  },
});
const onboardingUpdateSuccess = () => ({ type: OnboardingActionTypes.ONBOARDING_UPDATE_SUCCESS });
const onboardingUpdateFailure = () => ({ type: OnboardingActionTypes.ONBOARDING_UPDATE_FAILURE });

const wizardRegisterRequest = ({
  domain, origin,
}) => ({
  type: OnboardingActionTypes.WIZARD_REGISTER_REQUEST,
  payload: {
    domain, origin,
  },
});
const setWizardRegister = ({ wizardId }) => ({
  type: OnboardingActionTypes.SET_WIZARD_REGISTER,
  payload: {
    wizardId,
  },
});
const wizardRegisterSuccess = () => ({ type: OnboardingActionTypes.WIZARD_REGISTER_SUCCESS });
const wizardRegisterFailure = () => ({ type: OnboardingActionTypes.WIZARD_REGISTER_FAILURE });

const wizardUpdateRequest = ({
  wizardId, domain, origin, builder, finished,
}) => ({
  type: OnboardingActionTypes.WIZARD_UPDATE_REQUEST,
  payload: {
    wizardId, domain, origin, builder, finished,
  },
});
const wizardUpdateSuccess = preventChangeStart => ({ type: OnboardingActionTypes.WIZARD_UPDATE_SUCCESS, payload: { preventChangeStart } });
const wizardUpdateFailure = () => ({ type: OnboardingActionTypes.WIZARD_UPDATE_FAILURE });

const resetOnboarding = () => ({
  type: OnboardingActionTypes.RESET_ONBOARDING,
});

const actions = {
  onboarding: {
    reset: resetOnboarding,
    register: {
      request: onboardingRegisterRequest,
      success: onboardingRegisterSuccess,
      failure: onboardingRegisterFailure,
    },
    update: {
      request: onboardingUpdateRequest,
      success: onboardingUpdateSuccess,
      failure: onboardingUpdateFailure,
    },
  },
  wizard: {
    register: {
      request: wizardRegisterRequest,
      set: setWizardRegister,
      success: wizardRegisterSuccess,
      failure: wizardRegisterFailure,
    },
    update: {
      request: wizardUpdateRequest,
      success: wizardUpdateSuccess,
      failure: wizardUpdateFailure,
    },
  },
};

export default actions;
